import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { Button } from '@components/Button';
import { ReactComponent as JoyHeartIconSvg } from '@images/joy-heart.svg';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { CTALink } from '@components/CTALink';
import { TOP_BANNER_HEIGHT } from './Layout.constants';

export const StyledBannerContainer = styled(Flex)`
  height: ${TOP_BANNER_HEIGHT}px;
  background: ${themeColor('blue5')} !important;
`;

export const StyledNewLink = styled(Button)`
  font-family: AkkuratLLSub-RegularSubset;
  font-size: 15px;
  line-height: 22px;
  padding: 0px 6px;
  height: 24px;
  border-width: 1px;
  ${themeMediaQuery('sm')} {
    color: ${themeColor('purple1')};
    border-color: ${themeColor('purple1')};
  }
`;

export const StyledArrowIcon = styled(JoyHeartIconSvg)`
  transform: rotate(-90deg);
`;

export const StyledNavText = styled(Text)`
  font-size: 15px;
  line-height: 25px;

  :hover {
    color: ${themeColor('purple3')};
  }
  :active {
    color: ${themeColor('purple3')};
    opacity: 0.6;

    ${StyledArrowIcon} {
      transform: rotate(0deg);
    }
  }
`;

export const StyledSubText = styled(Text)`
  font-size: 15px;
  line-height: 25px;
  opacity: 0.8;
`;

export const StyledMobileCTALink = styled(CTALink)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledDesktopLinks = styled.div`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
